(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-wedding"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  console.log('Custom size script loaded ✅');

  const fieldsWrap = document.getElementById('measurement-fields');
  if (!fieldsWrap) return;

  const inputs = fieldsWrap.querySelectorAll('input, textarea, select');

  function toggleFields(show) {
    fieldsWrap.style.display = show ? 'block' : 'none';
    inputs.forEach(i => (i.required = show));
  }

  // ✅ Detect current selected variant on page load
  let selectedValue = '';

  // For radio buttons
  const checkedRadio = document.querySelector('input[type="radio"][name="size"]:checked');
  if (checkedRadio) {
    selectedValue = checkedRadio.value.toLowerCase();
  }

  // For dropdown (if no radios found)
  const selectedSelect = document.querySelector('select[name="options[Size]"]');
  if (selectedSelect) {
    selectedValue = selectedSelect.value.toLowerCase();
  }

  console.log('Page load selected size:', selectedValue);
  toggleFields(selectedValue.includes('custom'));

  // ✅ When user changes size
  document.body.addEventListener('change', function(e) {
    if (e.target.matches('input[type="radio"][name="size"], select[name="options[Size]"]')) {
      const value = e.target.value.toLowerCase();
      console.log('Size changed to:', value);
      toggleFields(value.includes('custom'));
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
